let sentryInitialized = false

export async function initSentry(): Promise<void> {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
  if (!dsn) return

  try {
    const Sentry = await import("@sentry/react")

    Sentry.init({
      dsn,
      environment: import.meta.env.MODE,
      release: (import.meta.env.VITE_APP_VERSION as string | undefined) ?? "0.1.0",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
      ],
      tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
      beforeSend(event) {
        // Scrub PII from URLs
        if (event.request?.url) {
          event.request.url = event.request.url.replace(/token=[^&]+/g, "token=REDACTED")
        }
        return event
      },
    })

    sentryInitialized = true
  } catch (err) {
    console.warn("Failed to initialize Sentry:", err)
  }
}

export async function setSentryUser(userId: string, email?: string): Promise<void> {
  if (!sentryInitialized) return
  try {
    const Sentry = await import("@sentry/react")
    Sentry.setUser({ id: userId, email })
  } catch { /* ignore */ }
}

export async function clearSentryUser(): Promise<void> {
  if (!sentryInitialized) return
  try {
    const Sentry = await import("@sentry/react")
    Sentry.setUser(null)
  } catch { /* ignore */ }
}

export async function captureException(error: Error, context?: Record<string, unknown>): Promise<void> {
  if (!sentryInitialized) return
  try {
    const Sentry = await import("@sentry/react")
    Sentry.captureException(error, { extra: context })
  } catch { /* ignore */ }
}
